module.exports = __webpack_public_path__ + "img/text-logo.b8135a1e.svg";